<form class="ui form" [formGroup]="modelForm">
   <!-- <i class="ace-icon fa fa-folder-o smaller-90"></i> {{model?.name}} field component -->
    <app-tabset >
		<div class="ui three item menu">
			<a class="item" appTabHeader="1" [isActive]="true">Display</a>
      <a class="item" appTabHeader="2">Calculations</a>
		</div>
		<div class="ui segment" appTabContent="1">
       <div *ngIf="model">
                <div class="field">
                  <label>Label</label> <span data-toggle="tooltip" data-placement="right" title="The label for this field that will appear next to it"><i class="glyphicon glyphicon-question-sign text-muted" ></i></span>
                  <input formControlName="label" (ngModelChange)="doSomething($event)" [(ngModel)]="model.label" type="text" class="form-control"
                  />
                  <span [ngClass]="{ 'has-error' : modelForm.get('label').dirty	&&	!modelForm.get('label').valid}" *ngIf="modelForm.get('label').dirty	&&	!modelForm.get('label').valid  && !modelForm.get('label').pending">
                            <span class="help-block"  *ngIf="modelForm.get('label').hasError('required')">This field is required.</span>
                  </span>
                </div>
                <div class="field">
                  <label>Name</label> <span data-toggle="tooltip" data-placement="right" title="The name of the field, must be unique"><i class="glyphicon glyphicon-question-sign text-muted"></i></span>
                  <input formControlName="name" [(ngModel)]="model.name" type="text" class="form-control" inputcase/>
                  <span [ngClass]="{ 'has-error' : modelForm.get('name').dirty	&&	!modelForm.get('name').valid}" *ngIf="modelForm.get('name').dirty	&&	!modelForm.get('name').valid  && !modelForm.get('name').pending">
                            <span class="help-block"  *ngIf="modelForm.get('name').hasError('columnName')">Only alphanumeric and underscore(_) characters are allowed.</span>
                  <span class="help-block" *ngIf="modelForm.get('name').hasError('required')">This field is required.</span>
                  </span>
                  <small class="red" *ngIf="error">This fieldname already exist within your app</small>
                </div>
                <div class="field">
                  <label>Hint</label> <span data-toggle="tooltip" data-placement="right" title="Brief explaination for fill this field"><i class="glyphicon glyphicon-question-sign text-muted" ></i></span>
                  <input formControlName="hint" type="text" class="form-control" [(ngModel)]="model.hint" />
                </div>
              </div>
    </div>
    		<div class="ui segment" appTabContent="2">
               <div class="field">
                  <textarea class="form-control" id="txtId" formControlName="calculation" [(ngModel)]="model.calculation" placeholder="e.g (${robustness_of_construction} * 8 ) + (${site_physically_secured} * 8) + (${potential_project_comp_risk} * 2) + ( ${risk_to_project_completion} * 2 )">
                            </textarea>
                  <label>list of available computable fields</label> <span data-toggle="tooltip" data-placement="right" title="Select operator"><i class="glyphicon glyphicon-question-sign text-muted" ></i></span>
                  <select class="form-control" (change)="fedMethod($event)">
                              <option>Select field </option>
                            <ng-template  ngFor let-com [ngForOf]="selectComponents" let-i="index">
                              <option *ngIf="com.type === 'integer'"  value="{{com.field}}">{{com.field}}</option>
                              </ng-template>
                            </select>
                </div>
                <div class="field">
                  <button type="button" (click)="calMethod('+')" class="btn btn-xs"> + </button>
                  <button type="button" (click)="calMethod('-')" class="btn btn-xs"> - </button>
                  <button type="button" (click)="calMethod('*')" class="btn btn-xs"> * </button>
                  <button type="button" (click)="calMethod('/')" class="btn btn-xs"> / </button>
                  <button type="button" (click)="calMethod('!==')" class="btn btn-xs">  !== </button>
                  <button type="button" (click)="calMethod('<')" class="btn btn-xs">  < </button>
                  <button type="button" (click)="calMethod('<=')" class="btn btn-xs">  <= </button>
                  <button type="button" (click)="calMethod('>')" class="btn btn-xs">  > </button>
                  <button type="button" (click)="calMethod('>=')" class="btn btn-xs">  >= </button>
                  <button type="button" (click)="calMethod('%')" class="btn btn-xs">  % </button>
                </div>
    </div>
    </app-tabset>
</form>
<div class="actions" appMargin marginT="10">
	<div fxLayout="row" fxLayoutGap="30px" fxLayoutAlign="center">
		<button class="ui basic primary button" (click)="onClose.emit()" >Cancel</button>
		<button class="ui primary button" [disabled]="!modelForm.valid" autofocus (click)="continue()">Confirm</button>
				<!-- <button class="ui primary button" autofocus>Update</button> -->
	</div>
</div>